import { Paper, PaperProps, Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InvoiceStatus } from '../api/gql';
import { getInvoiceStateProperties } from '../utils/invoice';
import { ExpandedBox } from './ExpandedBox';
import { FullSizeLoader } from './FullSizeLoader';

type Props = {
  status: InvoiceStatus;
  isLoading?: boolean;
  errorMessage?: string;
  titleProps?: TypographyProps;
} & PaperProps;

export const InvoiceStatusInfoBox = ({ status, isLoading, errorMessage, sx, titleProps, ...rest }: Props) => {
  const { t } = useTranslation();

  const properties = getInvoiceStateProperties(status, '');

  return (
    <Paper
      sx={{
        p: { md: 4, xs: 2 },
        position: 'relative',
        borderColor: properties.color,
        overflow: 'hidden',
        ...sx,
      }}
      {...rest}
    >
      {isLoading ? <FullSizeLoader /> : null}
      {errorMessage ? (
        <ExpandedBox sx={{ backdropFilter: 'blur(2px)', zIndex: 10 }}>
          <Typography>{errorMessage}</Typography>
        </ExpandedBox>
      ) : null}
      <Typography variant={'h3'} mb={2} {...titleProps}>
        {t('status')}
      </Typography>
      <Typography color={properties.color}>{t(properties?.transKey)}</Typography>
    </Paper>
  );
};
